
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { BiLoaderCircle } from "react-icons/bi";
import { Grid } from "@mui/material";
import toast from "react-hot-toast";
import moment from "moment";

import CustomModal from "../../../common/CustomModal";
import CustomButton from "../../../common/CustomButton";
import CustomSlider from "../../../common/CustomSlider";

import { UpdateUserPlan, LoadUserBillingData, ReactivateSubscription, } from "../../../redux/v2/user/actions";
import { convertCurrencySymbols } from "../../../constants"
import { apiCallV2 } from "../../../utils/api";
import CancelV2 from "./CancelV2";

function Subscription(props) {

    const { account } = props.User;
    const billing = account?.billingInfo;
    const [planArray, setPlanArray] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState({
        index: -1,
        info: {},
    });

    const label = {
        "1": {
            text1: "Monthly",
            text2: "Month",
        },

        "12": {
            text1: "Annual",
            text2: "Year",
        },
    }

    const getPlan = async () => {
        const res = await apiCallV2("GET", "get-subscription-plans");
        if (res.status === 200) {
            setPlanArray(res.data.data);

        }
    };

    useEffect(() => {
        getPlan();
    }, []);

    const isCancelled = billing?.hasCanceledSubscription;
    if (billing?.hasOwnProperty("createdAt") && selectedPlan.index == -1 && !isCancelled && planArray.length > 1) {

        const tempPlan = { ...planArray.filter(p => p.id == billing?.plan.id)[0] };

        setSelectedPlan({
            index: 1,
            info: { ...tempPlan }
        });
    }


    const billingPlan = billing?.plan;

    const Delay = (cb, time = 1000) => {
        let timer = setTimeout(() => {
            cb();
            clearTimeout(timer);
        }, time)
    }

    const [currentButton, setCurrentButton] = useState(0);
    let planChange = false;

    if (selectedPlan.info.code && !isCancelled) {
        planChange = billing?.hasOwnProperty("createdAt") ? selectedPlan.info.code.split("-")[0] != billingPlan.code.split("-")[0] : false;
    } else if (selectedPlan.info.code && isCancelled) {
        planChange = true;
    }

    let identifiedPlans = ["monthly-renewal", "annual-plan-renewal"];
    const currentPlanType = billing?.hasOwnProperty("createdAt") ? { ...planArray.filter(p => p.id == billing?.plan.id)[0] } : null;

    if (billing?.hasOwnProperty("createdAt")) {
        identifiedPlans[currentPlanType.interval_length == 1 ? 0 : 1] = currentPlanType.code;
    }

    let monthly = 0;
    const buttons = [
        <CustomButton
            onClick={() => {
                setCurrentButton(2);

                if (isCancelled) {
                    Delay(() => {
                        setCurrentButton(1);
                    }, 500);

                } else {
                    Delay(() => {
                        setShowModal(true);
                        // setCurrentButton(1);
                    }, 500);
                }
            }}
            disabled={!planChange}
        >
            {isCancelled ? "REACTIVATE PLAN" : "UPDATE"}
        </CustomButton>,

        <CustomButton
            onClick={async () => {
                setCurrentButton(2);

                if (isCancelled) { ///Reactivate Subscription

                    const res = await props.ReactivateSubscription();

                    if (res.success) {
                        props.LoadUserBillingData();
                        setCurrentButton(0);

                        toast.success("Plan successfully reactivated");
                    } else {
                        toast.error("Failed to reactivate plan");
                    }
                }
            }}
        >
            CONFIRM?
        </CustomButton>,

        <CustomButton>
            <BiLoaderCircle className="btn-loading" style={{ margin: "0" }} />
        </CustomButton>,

        <CustomButton>
            SAVED!
        </CustomButton>,
    ];

    const [showModal, setShowModal] = useState(false);

    const isComplete = billing?.hasOwnProperty("createdAt");

    const platform = localStorage.getItem("indi-platform");

    const status = account?.user?.company ? "ACTIVE" : (isComplete
        ? isCancelled
            ? `ACTIVE UNTIL ${(moment(new Date(billing?.currentPeriodEndsAt)).format("ll") + "").toUpperCase()}`
            : "ACTIVE"
        : "----");
    const currentPlan = account?.user?.company ? "CORPORATE" : (isComplete ? (label[currentPlanType.interval_length + ""]?.text1.toUpperCase()) : "----");
    const rate = account?.user?.company ? "N/A" : (isComplete ? `${convertCurrencySymbols(billing?.currency)}${billing?.total} PER ${label[currentPlanType.interval_length + ""]?.text2.toUpperCase()}` : "----");
    const nextBillDate = account?.user?.company ? "N/A" : (isComplete
        ? isCancelled
            ? "NONE"
            : moment(new Date(billing?.currentPeriodEndsAt)).format("L")
        : "----");

    return (
        <div id="subscription-form" className="my-account-form">

            <CustomModal
                toggle={() => {
                    setShowModal(!showModal)
                }}
                preToggle={() => {
                    setCurrentButton(0);
                }}
                id="change-plan-modal"
                show={showModal}
                title="CONFIRM CHANGES"
                body={
                    <>
                        <div id="confirm-message">
                            <p>
                                {`Your account will change to ${label[selectedPlan.info.interval_length + ""]?.text1} billing?. You will be charge ${convertCurrencySymbols(selectedPlan.info.currency) + "" + selectedPlan.info.amount} per ${label[selectedPlan.info.interval_length + ""]?.text2} at your next billing cycle.`}
                            </p>
                            <p mt="25px">
                                Next Bill Date: {moment(new Date(billing?.currentTermStartedAt)).format("LL")}
                            </p>
                        </div>
                    </>
                }
                footerButtons={
                    [
                        {
                            label: "Confirm",
                            action: async () => {
                                setShowModal(false);

                                let res;

                                if (selectedPlan.info.id == billing?.plan.id) {
                                    res = await props.ReactivateSubscription();
                                } else {
                                    res = await props.UpdateUserPlan({ planID: selectedPlan.info.id });
                                }

                                if (res.success) {
                                    Delay(() => {
                                        props.LoadUserBillingData();

                                        toast.success("Plan changed successfully");
                                        setCurrentButton(0);
                                    }, 1000);
                                } else {
                                    setCurrentButton(0);
                                }

                            },
                            className: "btn-black",
                        }

                    ]
                }
            />
            <div className="row">
                <div className="col-md-12">
                    <h4>CURRENT PLAN</h4>
                </div>

                <div className="col-md-12 mb-5">
                    <div className="row">
                        <div className="col-md-6 acc-detail">
                            <p>STATUS:</p>
                            <p>{status}</p>
                        </div>
                        <div className="col-md-6 acc-detail">
                            <p>CURRENT PLAN: </p>
                            <p>{currentPlan}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 acc-detail">
                            <p>RATE: </p>
                            <p>{rate}</p>
                        </div>
                        <div className="col-md-6 acc-detail">
                            <p>NEXT BILLING DATE:</p>
                            <p>{nextBillDate}</p>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <h4>CHANGE PLAN</h4>
                </div>

                <div className="col-md-12">
                    <div className="plan-v2-css">
                        {
                            billing?.hasOwnProperty("createdAt")
                                ? planArray.sort((a, b) => a.interval_length - b.interval_length)?.map((plan, i) => {
                                    let planIndex = identifiedPlans.indexOf(plan.code);

                                    if (plan.interval_length == 1) {
                                        monthly = plan.amount;
                                    }

                                    const criteria = planIndex == -1;

                                    let isYearly = plan.interval_length == 12;
                                    let off = Math.round(parseFloat(((plan.amount) / (monthly * 12) * 100 - 100) * -1).toFixed(1));

                                    const current = selectedPlan.info.interval_length == plan.interval_length;

                                    return criteria ? "" : (
                                        <div key={"asp-" + i} className={"clickable plan" + (current ? " selected g-pink" : "")}
                                            onClick={() => {
                                                setSelectedPlan({
                                                    index: i,
                                                    info: {
                                                        ...plan
                                                    }
                                                })
                                            }}
                                        >
                                            <Grid container spacing={0}>
                                                <Grid item xs={6}>
                                                    <div>
                                                        <h6>${plan.amount}/{plan?.interval_length == 12 ? "year" : "month"}</h6>
                                                        <h4>{plan.interval_length} MONTH{isYearly ? "S" : ""}</h4>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <h6>{isYearly ? `${off}% Off Monthly Plan` : "."}</h6>
                                                    <h4>${plan.amount} USD</h4>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    )
                                })
                                : ""
                        }
                    </div>
                </div>

                <div className="col-md-12 mt-4">
                    <div className='lower-button-action'>
                        <div>
                            {
                                buttons[currentButton]
                            }
                        </div>

                        {
                            !isCancelled && <>
                                <div className="cancel-link">
                                    <Link to={'/account'} onClick={(e) => {
                                        e.preventDefault();

                                        props.setShowSlider(true);
                                    }}>
                                        CANCEL PLAN
                                    </Link>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div >
    );
}

const mapStateToProps = (state) => ({
    User: state.User
});

export default connect(mapStateToProps, {
    UpdateUserPlan,
    LoadUserBillingData,
    ReactivateSubscription,
})(Subscription);
